import Link from "next/link";
import classNames from "classnames";

import ArrowNeIcon from "assets/icons/arrow-ne.svg";
import RaycastLogoNegIcon from "assets/icons/raycast-logo-neg.svg";

import BlueTag from "components/BlueTag";

import styles from "./SharedFooter.module.css";

const SharedFooter = () => {
  return (
    <footer className={styles.footer}>
      <div className={classNames(styles.footerColumns, styles.container)}>
        <div className={classNames(styles.footerColumn, styles.footerLogo)}>
          <div className={styles.logo}>
            <RaycastLogoNegIcon />
          </div>
        </div>
        <ul className={styles.footerColumn}>
          <h3 className={styles.footerColumnTitle}>Product</h3>
          <li className={styles.footerItem}>
            <a href="/store" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Store</span>
            </a>
          </li>
          <li className={styles.footerItem}>
            <Link href="/developers">
              <a aria-current="page" className={styles.footerLink}>
                <span className={styles.footerLinkText}>Developer</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/teams">
              <a aria-current="page" className={classNames(styles.footerLink, styles.linkWithTag)}>
                <span className={styles.footerLinkText}>Teams</span>
              </a>
            </Link>
            <BlueTag>New</BlueTag>
          </li>
          <li className={styles.footerItem}>
            <a
              href="https://developers.raycast.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              <span className={styles.footerLinkText}>API Docs</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <Link href="/pricing">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Pricing</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/changelog">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Changelog</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <a href="/manual" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Manual</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <a href="/troubleshooting" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Troubleshooting</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <Link href="/faq">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>FAQ</span>
              </a>
            </Link>
          </li>
        </ul>
        <ul className={classNames(styles.footerColumn, styles.product)}>
          <h3 className={classNames(styles.footerColumnTitle, styles.company)}>Company</h3>
          <li className={styles.footerItem}>
            <Link href="/careers">
              <a className={styles.footerLink}>
                <span className={classNames(styles.footerLinkText, styles.linkWithTag)}>Careers</span>
                <span className={styles.jobsCounter}>
                  <span>3</span>
                </span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/manifesto">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Manifesto</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/privacy">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Privacy Policy</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/terms-of-service">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Terms of Service</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <Link href="/dpa">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Data Process Agreement</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <a href="/press" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Press Kit</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <a href="mailto:hello@raycast.com" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Contact</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
        </ul>
        <ul className={classNames(styles.footerColumn, styles.community)}>
          <h3 className={styles.footerColumnTitle}>Community</h3>
          <li className={styles.footerItem}>
            <Link href="/community-stories">
              <a className={styles.footerLink}>
                <span className={styles.footerLinkText}>Community Stories</span>
              </a>
            </Link>
          </li>
          <li className={styles.footerItem}>
            <a href="/community" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Slack</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <a
              href="https://twitter.com/raycastapp"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              <span className={styles.footerLinkText}>Twitter</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <a
              href="https://github.com/raycast"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              <span className={styles.footerLinkText}>GitHub</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
          <li className={styles.footerItem}>
            <a
              href="https://dribbble.com/raycastapp"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.footerLink}
            >
              <span className={styles.footerLinkText}>Dribbble</span>
              <ArrowNeIcon className={classNames("icon", styles.arrowIcon)} />
            </a>
          </li>
        </ul>
        <ul className={styles.footerColumn}>
          <h3 className={classNames(styles.footerColumnTitle, styles.madeBy)}>By Raycast</h3>
          <li className={styles.footerItem}>
            <a href="/wallpapers" className={styles.footerLink}>
              <span className={styles.footerLinkText}>Wallpapers</span>
            </a>
          </li>
        </ul>
      </div>
      <span></span>
    </footer>
  );
};

export default SharedFooter;
